import React, { useState } from 'react';
import {Form, Button, Modal, Radio, Input} from 'antd';
import { CountDown } from '../countDown/countDown';

export const Dialog = ({ visible, generateCode, handleCancel, viewCode, identifyCode, resendCode }) => {
    const [value, setValue] = useState('EMAIL');

    const CloseSvg = () => (
        <svg width="24" height="24" viewBox="0 0 24 24">
            <path id="prefix__a" d="M20.993 5.02L14.013 12l6.98 6.98c.556.556.556 1.457 0 2.013-.556.556-1.457.556-2.013 0L12 14.013l-6.98 6.98c-.556.556-1.457.556-2.013 0-.556-.556-.556-1.457 0-2.013L9.987 12l-6.98-6.98c-.556-.556-.556-1.457 0-2.013.556-.556 1.457-.556 2.013 0L12 9.987l6.98-6.98c.556-.556 1.457-.556 2.013 0 .556.556.556 1.457 0 2.013z"/>
        </svg>
    );

    const handleChange = ({ target: { value } }) => {
        setValue(value)
    }

    const confirmCode = (values) => {
        identifyCode(values.code);
    }

    if (viewCode) {
        return (
            <Modal
                title="Վարկի հաստատում"
                onCancel={() => handleCancel(false)}
                bodyStyle={{ textAlign: 'center' }}
                wrapClassName='action-dialog'
                closeIcon={<CloseSvg />}
                visible={visible}
                footer={null}
                width={720}
                centered
            >
                <div className='form'>
                    <Form
                        layout='vertical'
                        initialValues={{ remember: true }}
                        onFinish={confirmCode}
                    >
                        <Form.Item
                            style={{ margin: '8px 0 44px' }}
                            label='Վավերականացման կոդ'
                            name='code'
                            rules={[{ required: true, message: 'Դաշտը պարտադիր է' }]}
                        >
                            <Input className='code' />
                        </Form.Item>
                        <Form.Item>
                            <Button
                                style={{ margin: '0 auto 8px', width: '192px', height: '48px' }}
                                className='btn-yellow'
                                size={"large"}
                                type="primary"
                                htmlType="submit"
                            >
                                Հաստատել
                            </Button>
                        </Form.Item>
                        <CountDown action={resendCode} />
                    </Form>
                </div>
            </Modal>
        );
    }

    return (
        <Modal
            title="Ընտրեք գործարքի հաստատման տարբերակ"
            onCancel={() => handleCancel(false)}
            bodyStyle={{ textAlign: 'center' }}
            wrapClassName='action-dialog'
            closeIcon={<CloseSvg />}
            visible={visible}
            footer={null}
            width={720}
            centered
        >
            <>
                <div className='radio-group'>
                    <Radio.Group onChange={handleChange} value={value}>
                        <Radio style={{ marginRight: '100px' }} value='EMAIL'>Էլ. հասցեով</Radio>
                        <Radio value='SMS'>Հեռախոսահամարով</Radio>
                    </Radio.Group>
                </div>
                <div className='actions'>
                    {value === 'EMAIL'
                        ? 'Այս տարբերակի ընտրության դեպքում հաճախորդի էլ. հասցեին ուղարկվում է նամակ հղումով, որը պետք է հաստատվի հաճախորդի կողմից։'
                        : 'Այս տարբերակի ընտրության դեպքում հաճախորդին կուղարկվի կոդ SMS հաղորդագրության միջոցով, որը պետք է մուտքագրվի համակարգ հաջորդ քայլում։'
                    }
                </div>

                <Button
                    style={{ margin: '30px 0 32px', width: '192px', height: '48px' }}
                    onClick={() => generateCode(value)}
                    className='btn-yellow'
                    size={"large"}
                >
                    Հաստատել
                </Button>
            </>
        </Modal>
    );
}

Dialog.propTypes = {};